module.exports = __webpack_public_path__ + "img/icon-share-light.ce1d2be8.svg";